// His cart-label formats (Z Furniture LFMT), in millimetres — apart from the label engine so a screen
// can list them without loading the PDF library. Names: "cartLabel.fmt.<key>" in the word list.
export type CartFormat = "zebra" | "ql62" | "a4x4";
export const CART_FORMATS: Record<CartFormat, { w: number; h: number; page?: [number, number]; slots?: [number, number][] }> = {
  zebra: { w: 150, h: 100 },
  ql62: { w: 100, h: 62 },
  a4x4: { w: 148.5, h: 105, page: [297, 210], slots: [[0, 0], [148.5, 0], [0, 105], [148.5, 105]] },
};
// His limits: carts 1 to 999, smallest first, at most 400 labels in one PDF.
export const cartId = (n: number) => `CH-${String(n).padStart(3, "0")}`;
export const MAX_CART_LABELS = 400;
